import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'

const body = css`
  line-height: 1.7;

  > * + * {
    margin-top: 60px;

    ${minMq('MD')} {
      margin-top: 80px;
    }
  }
`

const block = css`
  > * + * {
    margin-top: 40px;
  }
`

const list = css`
  display: grid;
  gap: 40px 50px;
  grid-template-columns: 1fr;

  ${minMq('MD')} {
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  }
`

const box = css`
  display: grid;
  row-gap: 16px;

  ${minMq('MD')} {
    row-gap: 24px;
  }
`

const boxTitle = css`
  font-weight: 700;
  margin-bottom: 16px;
`

const areaBlock = css`
  display: flex;

  > dt {
    flex-shrink: 0;
  }

  > dd {
    flex: 1;
  }
`

export const style = {
  body,
  block,
  list,
  box,
  boxTitle,
  areaBlock
}